module.exports = __webpack_public_path__ + "static/media/dishes.8bfff3c6.png";